export default `
    <div id= "#=data.id#_cid" class="pane-field #= data.bsc # #= data.containerClasses #">
        <div class="row">
            <span class="pane-field-label #=data.labelClasses# #=data.labelBsc #">
                # if(data.hcLabel) { #
                    <span data-label-for-id="#= data.id #" class="pane-field-text">
                        #=data.hcLabel #
                    </span>
                # } else { #
                    <span data-label-for-id="#= data.id #" class="pane-field-text bind-label" data-bind="#= data.bindLabel #">
                    </span>
                # } #
            </span>
            <span class="#= data.inputBsc # #if (data.clearable) { #clearable-input-container# }#">
                <a class="link pointer"
                    # if (data.disabled) { # disabled # } # id="#= data.id #"
                    # if (data.toolTip) { # title="#= data.toolTip #" # } #
                    # if (data.href) { # href="#= data.href #" # } #
                >
                    # if (data.toolTip) { # title="#= data.toolTip #" # } #
                    <span  data-label-for-id="#= data.id #" class="icon-label bind-value #=data.classes#" data-bind="#= data.bindValue #">
                    </span>
                </a>
                # if (data.cf && !data.hideSS) { #
                    <span class="cf" title="#= z.ll("CustomFieldLabelTitle", true) #">
                        C
                    </span>
                # } #
            </span>
        </div>
    </div>
`;
